import React from "react";
import "./style.css";
import { getCeoUrl } from "../../Helpers/SiteConfig";

const FounderCeoMessage = () => {
  return (
    <section
      className="home-about-area pt-120 pb-120 founder-message-section"
      id="message"
    >
      <div className="container">
        <div className="row align-items-center justify-content-between">
          <div className="col-lg-6 col-md-6 home-about-left">
            <div>
              <div className="menu-content">
                <div className="title">
                  <h1 className="mb-4">Founder and CEO's Message</h1>
                </div>
              </div>
              <a href={getCeoUrl()} className="primary-btn">
                Meet our Founder and CEO
              </a>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 home-about-right founderMessage">
            <div className="quote-icon-container">
              <svg
                className="quote-icon-1"
                fill="#000000"
                version="1.1"
                id="Capa_1"
                width="80px"
                height="80px"
                viewBox="0 0 123.961 123.961"
              >
                <g>
                  <path d="M49.8,29.032c3.1-1.3,4.4-5,3-8l-4.9-10.3c-1.4-2.899-4.8-4.2-7.8-2.899c-8.5,3.6-15.8,8.3-21.6,14   C11.4,28.532,6.6,36.232,4,44.732c-2.6,8.601-4,20.3-4,35.2v30.7c0,3.3,2.7,6,6,6h39.3c3.3,0,6-2.7,6-6v-39.3c0-3.301-2.7-6-6-6   H26.5c0.2-10.101,2.6-18.2,7-24.301C37.1,36.133,42.5,32.133,49.8,29.032z" />
                  <path d="M120.4,29.032c3.1-1.3,4.399-5,3-8l-4.9-10.199c-1.4-2.9-4.8-4.2-7.8-2.9c-8.4,3.6-15.601,8.3-21.5,13.9   c-7.101,6.8-12,14.5-14.601,23c-2.6,8.399-3.899,20.1-3.899,35.1v30.7c0,3.3,2.7,6,6,6H116c3.3,0,6-2.7,6-6v-39.3   c0-3.301-2.7-6-6-6H97.1c0.2-10.101,2.601-18.2,7-24.301C107.7,36.133,113.1,32.133,120.4,29.032z" />
                </g>
              </svg>
            </div>
            <h4 className="text-uppercase mb-2 mt-2 text-justify">
              At TZ Creation, we believe the fastest way to strengthen a
              product team isn't another agency retainer — it's senior design
              and engineering talent that actually joins the team. That's what
              we build: staff augmentation and dedicated partnerships for
              healthcare, edtech, and HR tech products, backed by work we've
              actually shipped, not just pitched.
            </h4>

            <div className="quote-icon-container">
              <svg
                className="quote-icon-2"
                fill="#000000"
                version="1.1"
                id="Capa_1"
                width="80px"
                height="80px"
                viewBox="0 0 123.961 123.961"
              >
                <g>
                  <path d="M49.8,29.032c3.1-1.3,4.4-5,3-8l-4.9-10.3c-1.4-2.899-4.8-4.2-7.8-2.899c-8.5,3.6-15.8,8.3-21.6,14   C11.4,28.532,6.6,36.232,4,44.732c-2.6,8.601-4,20.3-4,35.2v30.7c0,3.3,2.7,6,6,6h39.3c3.3,0,6-2.7,6-6v-39.3c0-3.301-2.7-6-6-6   H26.5c0.2-10.101,2.6-18.2,7-24.301C37.1,36.133,42.5,32.133,49.8,29.032z" />
                  <path d="M120.4,29.032c3.1-1.3,4.399-5,3-8l-4.9-10.199c-1.4-2.9-4.8-4.2-7.8-2.9c-8.4,3.6-15.601,8.3-21.5,13.9   c-7.101,6.8-12,14.5-14.601,23c-2.6,8.399-3.899,20.1-3.899,35.1v30.7c0,3.3,2.7,6,6,6H116c3.3,0,6-2.7,6-6v-39.3   c0-3.301-2.7-6-6-6H97.1c0.2-10.101,2.601-18.2,7-24.301C107.7,36.133,113.1,32.133,120.4,29.032z" />
                </g>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderCeoMessage;
